import { render, staticRenderFns } from "./IcoSkillsDomainBusiness.vue?vue&type=template&id=567fc569"
import script from "./IcoSkillsDomainBusiness.vue?vue&type=script&lang=js"
export * from "./IcoSkillsDomainBusiness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports